import {
    Typography
} from '@mui/material';

export default function Address() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Blk 28 Sin Ming Lane'}
            <br />
            {'#05-135 Midview City'}
            <br />
            {'Singapore 573972'}
        </Typography>);
}